import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const ProtectedRoute = ({ allowedRoles, children }) => {

  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  } else if (user && user.claims && !user.claims.businessProfile) {
    return <Navigate to="/setup-profile" />
  }

  return children;
};

export default ProtectedRoute;